// Precollection Page Common JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all precollection sections
  initPrecollectionSections();
});

function initPrecollectionSections() {
  // Initialize Hero Video/Image section
  initHeroSection();
  
  // Initialize Honorable Mentions section
  initHonorableMentions();
  
  // Initialize Golf Simulator Packages sections
  initGolfSimulatorPackages();
  
  // Initialize FAQ Tabs section
  initFAQTabs();
}

function initHeroSection() {
  const heroSections = document.querySelectorAll('.hero-video-simple');
  
  heroSections.forEach((sectionEl) => {
    if (!sectionEl) return;

    const HeroSection = {
      init() {
        this.setupHeroImage();
      },
      
      setupHeroImage() {
        // Handle hero image background
        const heroImage = sectionEl.querySelector('.hero-image[data-image-url]');
        if (heroImage) {
          const imageUrl = heroImage.getAttribute('data-image-url');
          if (imageUrl) {
            heroImage.style.backgroundImage = `url('${imageUrl}')`;
          }
        }
      }
    };

    HeroSection.init();
  });
}

function initHonorableMentions() {
  const sectionEl = document.querySelector('[data-section-type="honorable-mentions"]');
  if (!sectionEl) return;

  const HonorableMentions = {
    init() {
      this.enhanceAccessibility();
      this.handleExternalLinks();
    },
    
    enhanceAccessibility() {
      // Add ARIA labels to buttons
      const buttons = sectionEl.querySelectorAll('.precollection-btn');
      buttons.forEach((button) => {
        if (!button.getAttribute('aria-label')) {
          button.setAttribute('aria-label', button.textContent.trim());
        }
      });
      
      // Add ARIA labels to product links
      const productLinks = sectionEl.querySelectorAll('.product-link');
      productLinks.forEach((link) => {
        if (!link.getAttribute('aria-label')) {
          link.setAttribute('aria-label', `View ${link.textContent.trim()}`);
        }
      });
    },
    
    handleExternalLinks() {
      const links = sectionEl.querySelectorAll('a[href^="http"]');
      links.forEach((link) => {
        try {
          const isExternal = link.hostname && link.hostname !== window.location.hostname;
          if (isExternal) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
          }
        } catch (e) {}
      });
    }
  };

  HonorableMentions.init();
}

function initGolfSimulatorPackages() {
  const packageSections = document.querySelectorAll('[data-section-type="golf-simulator-packages"]');
  
  packageSections.forEach((sectionEl) => {
    if (!sectionEl) return;

    const GolfSimulatorPackages = {
      init() {
        this.enhanceAccessibility();
        this.handleExternalLinks();
      },
      
      enhanceAccessibility() {
        // Add ARIA labels to buttons
        const buttons = sectionEl.querySelectorAll('.precollection-btn');
        buttons.forEach((button) => {
          if (!button.getAttribute('aria-label')) {
            button.setAttribute('aria-label', button.textContent.trim());
          }
        });
      },
      
      handleExternalLinks() {
        const links = sectionEl.querySelectorAll('a[href^="http"]');
        links.forEach((link) => {
          try {
            const isExternal = link.hostname && link.hostname !== window.location.hostname;
            if (isExternal) {
              link.setAttribute('target', '_blank');
              link.setAttribute('rel', 'noopener noreferrer');
            }
          } catch (e) {}
        });
      }
    };

    GolfSimulatorPackages.init();
  });
}

function initFAQTabs() {
  const tabLinks = document.querySelectorAll('.tab-nav-link');
  const tabContents = document.querySelectorAll('.tab-content-item');

  tabLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Remove active class from all tabs and contents
      tabLinks.forEach(l => l.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Show corresponding content
      const targetId = this.getAttribute('data-tab');
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}
